import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstLetterUppercase',
    standalone: true
})
export class FirstLetterUppercasePipe implements PipeTransform {

    transform(value: string | string[]): string {
        let wordFirstLetterUppercase = '';
        if (Array.isArray(value)) {
            value.forEach((word: string) => {
                wordFirstLetterUppercase += ((word.charAt(0).toUpperCase() + word.slice(1)) + ' ');
            });
        }

        if (typeof value === 'string' && value.split(' ').length > 1) {
            value.split(' ').forEach((word, index) => {
                if (index === 0) {
                    wordFirstLetterUppercase = (word.charAt(0).toUpperCase() + word.slice(1));
                } else {
                    wordFirstLetterUppercase += (' ' + word);
                }
            });
        }

        if (typeof value === 'string' && value.split(' ').length === 1) {
            wordFirstLetterUppercase = value.charAt(0).toUpperCase() + value.slice(1);
        }

        return wordFirstLetterUppercase;
    }

}
